import SuitabilityCodeStatusDisplay from './SuitabilityCodeStatusDisplay'

export default SuitabilityCodeStatusDisplay
